var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather feather-plus",
    fill: "none",
    height: 24,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 5,
    y2: 19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 19,
    y1: 12,
    y2: 12
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.f6872c6c44907bb0dc4775744a63d546.svg";